export default __webpack_public_path__ + "public/images/services/Сhat@3x.png?a7b98611";